import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { AccountMetricInsightsMetricType } from '../../../../interface/dtos';
import { ChallengeSelfReportAverageEntity } from '../../entities/challenge-insights/self-report/challenge-self-report-average.entity';

export interface ChallengeSelfReportAverageAggregateRootProps {
  before: ChallengeSelfReportAverageEntity;
  after: ChallengeSelfReportAverageEntity;
}

export class ChallengeSelfReportAverageAggregateRoot extends Entity<ChallengeSelfReportAverageAggregateRootProps> {
  protected _id: string;
  static create(
    props: ChallengeSelfReportAverageAggregateRootProps,
    entityId?: string
  ): ChallengeSelfReportAverageAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeSelfReportAverageAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  get metricType(): AccountMetricInsightsMetricType {
    return this.props.after.metricType;
  }

  get type() {
    return this.props.after.type;
  }

  get beforeValue() {
    return this.props.before.value;
  }
  get value() {
    return this.props.after.value;
  }
  get beforeAverage() {
    return this.props.before.average;
  }
  get average() {
    return this.props.after.average !== 0
      ? this.props.after.average
      : this.props.after.value;
  }
  get deviation() {
    return this.value - this.beforeValue;
  }
  get averageDeviation() {
    return this.average - this.beforeAverage;
  }
  get deviationPercentage() {
    return this.deviation !== 0 && this.beforeValue !== 0
      ? 100 * (this.deviation / this.beforeValue)
      : 0;
  }
  get averageDeviationPercentage() {
    return this.averageDeviation !== 0 && this.beforeAverage !== 0
      ? 100 * (this.averageDeviation / this.beforeAverage)
      : 0;
  }

  get uniqueUsersCount(): number {
    return this.props.after.uniqueUsers;
  }

  get beforeUniqueUsersCount(): number {
    return this.props.before.uniqueUsers;
  }
}
